import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontIcon from 'components/FontIcon';
import classes from './CardImageG.module.scss';

class CardImageG extends Component {
  constructor() {
    super();

    this.state = {
      expanded: false,
    };
  }

  toggle = () => {
    this.setState(({ expanded }) => ({
      expanded: !expanded,
    }));
  };

  render() {
    const {
      imageURI,
      imageAltText = '',
      heading,
      subHeading,
      contentMarkup,
      longContentMarkup,
      imageHeight,
      imageWidth,
    } = this.props;

    const {
      expanded,
    } = this.state;

    const description = `${contentMarkup}${longContentMarkup ? `\n\n${longContentMarkup}` : ''}`;

    return (
      <div className={classNames(classes.wrapper, { [classes.expanded]: expanded })}>
        {imageURI && (
          <span className={classes.imageWrapper}>
            <img
              className={classes.image}
              src={imageURI}
              alt={imageAltText}
              width={imageWidth}
              height={imageHeight}
              loading='lazy'
              aria-hidden
            />
          </span>
        )}
        <div className={classes.contentWrapper}>
          <div className={classes.headersWrapper}>
            {imageURI && (
              <span className={classes.mobileImageWrapper}>
                <img
                  className={classes.image}
                  src={imageURI}
                  alt={imageAltText}
                  width={imageWidth}
                  height={imageHeight}
                  loading='lazy'
                  aria-hidden
                />
              </span>
            )}
            <div className={classes.buttonAndHeadersWrapper}>
              <div className={classes.mobileButtonWrapper}>
                <button
                  aria-label={expanded ? 'Show Less' : 'Show More'}
                  className={classes.button}
                  onClick={this.toggle}
                  type='button'
                >
                  {expanded ? (
                    <FontIcon icon='far fa-minus' />
                  ) : (
                    <FontIcon icon='far fa-plus' />
                  )}
                </button>
              </div>
              {heading && <h2
                className={classes.header}
                dangerouslySetInnerHTML={{ __html: heading }}
              />}
              {subHeading && <h3
                className={classes.subheader}
                dangerouslySetInnerHTML={{ __html: subHeading }}
              />}
            </div>
          </div>
          {(description || contentMarkup) && <div
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: expanded ? description : contentMarkup,
            }}
          />}
          {typeof window === 'undefined' &&
            <div
              dangerouslySetInnerHTML={{
                __html: longContentMarkup,
              }}
            />}
          {!longContentMarkup ? null : (
            <div className={classes.buttonWrapper}>
              <button
                aria-label={expanded ? 'Read Less' : 'Read More'}
                className={classes.button}
                onClick={this.toggle}
                type='button'
              >
                {expanded ? (
                  <span>Read less</span>
                ) : (
                  <span>Read more</span>
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CardImageG.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Sub heading on the card
  */
  subHeading: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  /**
   * Image alternate text that displays on hover over of image
  */
  imageAltText: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Content of the card for when clicking Read More
  */
  longContentMarkup: PropTypes.string,
  /**
   * Pixel height of image
  */
  imageHeight: PropTypes.number,
  /**
   * Pixel width of image
  */
  imageWidth: PropTypes.number,
};

export default CardImageG;
